/* eslint-disable tailwindcss/no-arbitrary-value */
type Props = {
  embedUrl: string;
  sectionTitle?: string | null;
};

export const InstagramEmbed = ({ embedUrl, sectionTitle }: Props) => (
  <div className="w-full max-w-82 md:max-w-general/5-col-width lg:max-w-general/4-col-width">
    <div className="w-full overflow-hidden rounded-radius/table border border-borders/default bg-fill/card">
      <iframe
        key={embedUrl}
        src={embedUrl}
        className="h-[632px] w-full overflow-hidden border-0 md:h-[692px] md:w-full lg:h-[684px]"
        allowFullScreen
        loading="lazy"
        scrolling="no"
        style={{ maxWidth: '100%', overflow: 'hidden' }}
        title={sectionTitle || 'Instagram embed'}
      />
    </div>
  </div>
);
